import { FormKitTypeDefinition } from '@formkit/core'
import {
  outer,
  inner,
  wrapper,
  label,
  help,
  messages,
  message,
  prefix,
  suffix,
  icon,
  textareaInput,
  initialValue,
} from '../compose'

/**
 * Input definition for a textarea.
 * @public
 */
export const textarea: FormKitTypeDefinition = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* #__PURE__ */ outer(
    /* #__PURE__ */ wrapper(
      /* #__PURE__ */ label('$label'),
      /* #__PURE__ */ inner(
        /* #__PURE__ */ icon('prefix', 'label'),
        /* #__PURE__ */ prefix(),
        /* #__PURE__ */ textareaInput(),
        /* #__PURE__ */ suffix(),
        /* #__PURE__ */ icon('suffix')
      )
    ),
    /* #__PURE__ */ help('$help'),
    /* #__PURE__ */ messages(/* #__PURE__ */ message('$message.value'))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: 'input',
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [initialValue],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: 'b1n0td79m9g',
}
